export const YIELD_SET = {
  ALL: "ALL",
};

export const UNIT_STATUS = {
  ALL: "ALL",
  RUNNING: "RUNNING",
  PAUSED: "PAUSED",
};

export const UNIT_MODE = {
  ALL: "ALL",
  INITIAL: "INITIAL",
  NORMAL: "NORMAL",
  WATCH_LIST: "WATCH_LIST",
  SUSPENDED: "SUSPENDED",
};

export const SPECIAL_UNIT_TYPE = {
  ALL: "ALL",
  EXP: "explicitlyTargeted",
  ANC_EXP: "hasExplicitlyTargetedAncestor",
};

export const REQUEST_TYPE = {
  ALL: "ALL",
};

export const SEARCH_KEYS = {
  // ALL: "ALL",
  UNIT_ID: "adUnitId",
  EXT_UNIT_ID: "extGamAdUnitId",
  NAME: "name",
  PARENT_PATH: "parentPath",
  SITE_NETWORK_CODE: "siteNetworkCode",
  TAGS: "tags",
};

export const MATCH = {
  ALL: "ALL",
  ANY: "ANY",
  NONE: "NONE",
  ONLY: "ONLY",
};
